import { render, staticRenderFns } from "./_AcceptCollectionDetail.vue?vue&type=template&id=21171519&scoped=true&"
import script from "./_AcceptCollectionDetail.vue?vue&type=script&lang=js&"
export * from "./_AcceptCollectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./_AcceptCollectionDetail.vue?vue&type=style&index=0&id=21171519&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21171519",
  null
  
)

export default component.exports